import {createLazyComponent} from 'helpers/createLazyComponent'
import React from 'react'


const MissalPageEditorLazy = createLazyComponent(() => import('./MissalPageEditor'))

const MissalPageEditor = (props) => <MissalPageEditorLazy {...props} />

export default MissalPageEditor
